var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"day-header-container"},[_c('span',{staticClass:"weekday-text"},[_vm._v(_vm._s(_vm.desktopView ? _vm.weekdayText : _vm.weekdayText[0]))]),(!!_vm.dayNumber)?_c('div',{staticClass:"day-number-container",class:_vm.isToday ? 'today' : ''},[_c('span',{staticClass:"day-number-text"},[_vm._v(_vm._s(_vm.dayNumber))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }